import React, { useState } from 'react';
import Form from '../../Form';
import Input from '../../Input';

const BasicRequirementsForm = ({ onClose, leadData, leadUpdateMutate }) => {
  const preference = leadData?.preference || {};

  const [isDateUpdated, setIsDateUpdated] = useState(false);
  const [updatedData, setUpdatedData] = useState({
    bedroom: preference.bedroom ?? '',
    bathroom: preference.bathroom ?? '',
    moveIn: preference.moveIn ?? null,
    budgetMin: preference.budgetMin ?? ''
  });

  const handleChange = (key, value) => {
    setUpdatedData(prev => ({ ...prev, [key]: value }));
    if (key === 'moveIn') {
      setIsDateUpdated(true);
    }
  };

  const handleSave = () => {
    const record = {};
    if (updatedData.bedroom !== '' && updatedData.bedroom != null) {
      record.bedroom = parseInt(updatedData.bedroom);
    }
    if (updatedData.bathroom !== '' && updatedData.bathroom != null) {
      record.bathroom = parseInt(updatedData.bathroom);
    }
    if (updatedData.moveIn) {
      record.moveIn = updatedData.moveIn;
    }
    if (updatedData.budgetMin !== '' && updatedData.budgetMin != null) {
      record.budgetMin = updatedData.budgetMin;
    }

    leadUpdateMutate({
      variables: {
        leadId: leadData?._id,
        record: { preference: record }
      }
    });
    onClose();
  };

  const createDateString = date => {
    if (!date) return null;
    const objDate = new Date(date);
    let day = objDate.getDate();
    let month = objDate.getMonth() + 1;
    const year = objDate.getFullYear();

    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;
    return `${year}-${month}-${day}`;
  };

  return leadData?._id ? (
    <Form header="Basic Requirements" onClose={onClose} onSave={handleSave}>
      <Input
        size="xs"
        onChange={e => handleChange('bedroom', e.target.value)}
        value={updatedData.bedroom !== undefined ? updatedData.bedroom : ''}
        placeholder="Enter here"
        label="Bed"
      />
      <Input
        size="xs"
        onChange={e => handleChange('bathroom', e.target.value)}
        value={updatedData.bathroom !== undefined ? updatedData.bathroom : ''}
        label="Bath"
        placeholder="Enter here"
      />
      <Input
        size="xs"
        onDateChange={val => handleChange('moveIn', createDateString(val))}
        value={
          isDateUpdated
            ? updatedData.moveIn
              ? new Date(updatedData.moveIn)
              : null
            : preference.moveIn
              ? preference.moveIn !== 'currently_available'
                ? new Date(preference.moveIn)
                : new Date()
              : null
        }
        label="Move-in"
        date
        prepend
      />
      <Input
        size="xs"
        onChange={e => handleChange('budgetMin', e.target.value)}
        value={updatedData.budgetMin !== undefined ? updatedData.budgetMin : ''}
        label="Budget"
        placeholder="Enter here"
      />
    </Form>
  ) : null;
};

export default BasicRequirementsForm;
